import { Loader2 } from "lucide-react";

export const HealthBadge = ({ platform, health, checking }) => {
    if (checking && !health) {
        return (
            <p data-testid={`channel-health-${platform}`} className="mt-2 flex items-center gap-2 text-xs text-slate-300/50">
                <Loader2 className="h-3 w-3 animate-spin" /> Checking login…
            </p>
        );
    }
    if (!health) return null;
    const ok = health.healthy;
    return (
        <div
            data-testid={`channel-health-${platform}`}
            data-healthy={ok ? "true" : "false"}
            className={`mt-3 rounded-xl border px-3 py-2 text-xs leading-relaxed ${
                ok
                    ? "border-emerald-500/25 bg-emerald-500/10 text-emerald-300"
                    : "border-red-500/30 bg-red-500/10 text-red-300"
            }`}
        >
            <span className="flex items-center gap-2 font-semibold">
                <span className={`h-2 w-2 rounded-full ${ok ? "bg-emerald-400" : "bg-red-400 animate-pulse"}`} />
                {ok ? "Login working" : "Needs reconnecting"}
            </span>
            <span data-testid={`channel-health-msg-${platform}`} className="mt-1 block opacity-80">
                {health.message}
            </span>
        </div>
    );
};
